import { ReactNode } from 'react';
import UDEmptyButton from 'ud-ui/components/empty-button';
import UDTippy from 'ud-ui/components/tippy';

interface AlignmentButtonProps {
  /** Текст подсказки над кнопкой. */
  tooltip: string;
  onClick: () => void;
  /** Иконка кнопки. */
  children: ReactNode;
}

/** Кнопка панели выравнивания правого тулбара: иконка с подсказкой. */
function AlignmentButton(props: AlignmentButtonProps) {
  const { tooltip, onClick, children } = props;

  return (
    <UDTippy content={tooltip} size="xs" placement="bottom" delay={300}>
      <span style={{ display: 'inline-block' }}>
        <UDEmptyButton onClick={onClick}>{children}</UDEmptyButton>
      </span>
    </UDTippy>
  );
}

export default AlignmentButton;
